export default "__VITE_ASSET__CSpPEySB__"